import { render, staticRenderFns } from "./t-wizard.vue?vue&type=template&id=2f420886&"
import script from "./t-wizard.vue?vue&type=script&lang=js&"
export * from "./t-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports